// Import React
import React from "react";
import { NavLink } from "react-router-dom";

// Import CSS
import "./NavigationBar.css";

const NavigationBar = () => {
  return (
    <div className='navigation-bar'>
      <div className='nav-items'>
        <NavLink
          to='/'
          className={({ isActive }) => (isActive ? "active-link" : "nav-link")}>
          Home
        </NavLink>

        <NavLink
          to='/contact'
          className={({ isActive }) => (isActive ? "active-link" : "nav-link")}>
          Contact
        </NavLink>
      </div>
    </div>
  );
};

export default NavigationBar;
